import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Template } from '../../Components/Template/template'
import { IoAddCircleSharp, IoSave } from 'react-icons/io5'
import { Link, useParams } from 'react-router-dom'
import { FcNook } from 'react-icons/fc'
import { AlertType, CFOP, CstICMS, GrupoTrib, InputsRefs, barraVermelhoAzul, bgBlue, bgRed, classBorderError, classBorderLabelDark, classBt, classDivBackground, classDivBody, classDtCriarAtt, classInput, classInputDark, classLabel, classLabelDark, classUserCriarAtt, classWeigthBt, classbtAzul, classbtCinzaClaro, classbtColunasVermelho, classbtVerde, classbtVermelho, focusLabelRed, focusRed } from '../../Utils/Types'
import { FeedbackMessage } from '../../Components/FeedbackMessage/feedback-message'
import { Funcoes } from '../../Utils/Funcoes'
import { GrupoTribAttributes, TributacaoService } from './TributacaoService'
import { CfopService } from '../../Utils/CfopService'
import { BsBoxArrowInLeft } from 'react-icons/bs'
import moment from 'moment'
import { faClipboardList, faFolder } from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { Icone } from '../../Components/Icones/Index'
import { SearchBox } from '../../Components/SearchBox/SearchBox'
import { AiOutlineClear } from 'react-icons/ai'
import { FaRegQuestionCircle } from 'react-icons/fa'
import { Tooltip } from 'react-tooltip'

type CampoObrigatorio = {
    campo: string,
    erro: boolean,
}

export const TributacaoNew = () => {

    // ----------------- TABS --------------------------------------------------------
    type Tab = {
        index: number,
        titulo: String,
        active: boolean,
        icon: IconProp,
    }

    const itabs: Tab[] = [
        { index: 0, titulo: 'Dados Principais', active: true, icon: faFolder },
        { index: 1, titulo: 'Auditoria', active: false, icon: faClipboardList },
    ]

    const [tabs, setTabs] = useState<Tab[]>(itabs)

    // ------------- CAMPOS OBRIGATORIOS ----------------------------------------------
    const fieldsMandatory: CampoObrigatorio[] = [
        { campo: 'descricao', erro: false }, // Posição 0 do Array.    
    ]

    const [CamposObrigatorios, setCamposObrigatorios] = useState<CampoObrigatorio[]>(fieldsMandatory)

    // ------------------ ATRIBUTOS ---------------------------------------------------
    const { idTrib } = useParams<string>()
    const { idTribDup } = useParams<string>()
    const [id, setId] = useState(0)

    const newGrupoTrib: GrupoTrib = {
        id: 0,
        descricao: '',
        pICMS: 0,
        pPIS: 0,
        pCOFINS: 0,
        cstPisCofins: '',
        cfopSDentro: '',
        cfopSFora: '',
        cfopEdentro: '',
        cfopEfora: '',
        cstICMSDentro: '',
        cstICMSFora: '',
        dt_cadastro: '',
        id_user_insert: 0,
        name_user_insert: '',
        dt_last_update: '',
        name_user_last_update: '',
        description: ''
    }
    const [attributes, setAttributes] = useState<GrupoTribAttributes>({ grupoTrib: newGrupoTrib, cstList: [] })

    const [descricao, setDescricao] = useState("")
    const [descricaoCopia, setDescricaoCopia] = useState("")
    const [pICMS, setPICMS] = useState("")
    const [pPIS, setPPIS] = useState("")
    const [pCOFINS, setPCOFINS] = useState("")
    const [cstPisCofins, setCstPisCofins] = useState("")

    // CFOP DE ENTRADA DENTRO
    //const [cfopEdentro, setCfopEdentro]                               = useState("")
    const [listCFOPEntInterno, setListCFOPEntInterno] = useState<CFOP[]>([])
    const [idCfopEntradaDentro, setIdCfopEntradaDentro] = useState(0)
    const [listaCFOPEntradaDentroBox, setListaCFOPEntradaDentroBox] = useState<CFOP[]>([])

    // CFOP DE ENTRADA FORA
    //const [cfopEfora, setCfopEfora]                                   = useState("")
    const [listCFOPEntFora, setListCFOPEntFora] = useState<CFOP[]>([])
    const [idCfopEntradaFora, setIdCfopEntradaFora] = useState(0)
    const [listaCFOPEntradaForaBox, setListaCFOPEntradaForaBox] = useState<CFOP[]>([])

    // CFOP DE SAIDA DENTRO
    //const [cfopSDentro, setCfopSDentro]                           = useState("")
    const [listCFOPSaiInterno, setListCFOPSaiInterno] = useState<CFOP[]>([])
    const [idCfopSaidaDentro, setIdCfopSaidaDentro] = useState(0)
    const [listaCFOPSaidaDentroBox, setListaCFOPSaidaDentroBox] = useState<CFOP[]>([])

    // CFOP DE SAIDA DENTRO
    //const [cfopSFora, setCfopSFora] = useState("")
    const [listCFOPSaiFora, setListCFOPSaiFora] = useState<CFOP[]>([])
    const [idCfopSaidaFora, setIdCfopSaidaFora] = useState(0)
    const [listaCFOPSaidaForaBox, setListaCFOPSaidaForaBox] = useState<CFOP[]>([])

    // ICMS DENTRO
    const [cstDentroList, setCstDentroList] = useState<CstICMS[]>([])
    const [idCstDentro, setIdCstDentro] = useState("")
    //const [codCstDentro, setCodCstDentro]             = useState("")

    // ICMS FORA 
    const [cstForaList, setCstForaList] = useState<CstICMS[]>([])
    const [idCstFora, setIdCstFora] = useState("")
    //const [codCstFora, setCodCstFora]         = useState("")

    // ---------- ATRIBUTOS FEEDBACK -------------------------------------------------
    const [visible, setVisible] = useState(false)
    const [loading, setLoading] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS AUDITORIA -------------------------------------------------
    const [userCriador, setUserCriador] = useState("")
    const [dtCriador, setDtCriador] = useState("")
    const [usertAtt, setUsertAtt] = useState("")
    const [dtAtt, setDtAtt] = useState("")

    // ---------- SEARCHBOX -----------------------------------------------------------
    const [visibleSearchBoxEntradaDentro, setVisibleSearchBoxEntradaDentro] = useState<boolean>(false)
    const [visibleSearchBoxEntradaFora, setVisibleSearchBoxEntradaFora] = useState<boolean>(false)
    const [visibleSearchBoxSaidaDentro, setVisibleSearchBoxSaidaDentro] = useState<boolean>(false)
    const [visibleSearchBoxSaidaFora, setVisibleSearchBoxSaidaFora] = useState<boolean>(false)
    const [visibleSearchBoxICMSDentro, setVisibleSearchBoxICMSDentro] = useState<boolean>(false)
    const [visibleSearchBoxICMSFora, setVisibleSearchBoxICMSFora] = useState<boolean>(false)


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- ATRIBUTOS E EFFECT --------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const getAttributes = async () => {

        setLoading(true)

        try {

            const tribAttributes = await TributacaoService.GetAttributes(idTrib || idTribDup || id.toString())
            setAttributes(tribAttributes.data)

            const newCstDentroList = await tribAttributes.data.cstList.filter((item: any) => item.id.trim().substring(0, 1) === "0")
            setCstDentroList(newCstDentroList)

            const newCstForaList = await tribAttributes.data.cstList.filter((item: any) => item.id.trim().substring(0, 1) != "0")
            setCstForaList(newCstForaList)

            const listCFOPEntrada = await CfopService.List('E')
            const listCFOPSaida = await CfopService.List('S')

            let newCFOPList = await listCFOPEntrada.data.filter((item: any) => item.codigo.toString().charAt(0) === '1')
            setListCFOPEntInterno(newCFOPList)
            setListaCFOPEntradaDentroBox(newCFOPList)

            newCFOPList = await listCFOPEntrada.data.filter((item: any) => item.codigo.toString().charAt(0) === '2')
            setListCFOPEntFora(newCFOPList)
            setListaCFOPEntradaForaBox(newCFOPList)

            newCFOPList = await listCFOPSaida.data.filter((item: any) => item.codigo.toString().charAt(0) === '5')
            setListCFOPSaiInterno(newCFOPList)
            setListaCFOPSaidaDentroBox(newCFOPList)

            newCFOPList = await listCFOPSaida.data.filter((item: any) => item.codigo.toString().charAt(0) === '6')
            setListCFOPSaiFora(newCFOPList)
            setListaCFOPSaidaForaBox(newCFOPList)


            if (tribAttributes.data && idTrib) {

                setId(tribAttributes.data.grupoTrib.id || 0)
                setDescricao(tribAttributes.data.grupoTrib.descricao || '')
                setDescricaoCopia(tribAttributes.data.grupoTrib.descricao || '')
                setPICMS(tribAttributes.data.grupoTrib.pICMS?.toString() || '')
                setPPIS(tribAttributes.data.grupoTrib.pPIS?.toString() || '')
                setPCOFINS(tribAttributes.data.grupoTrib.pCOFINS?.toString() || '')
                setCstPisCofins(tribAttributes.data.grupoTrib.cstPisCofins || '')

                setIdCfopEntradaDentro(parseInt(tribAttributes.data.grupoTrib.cfopEdentro || ''))
                setIdCfopEntradaFora(parseInt(tribAttributes.data.grupoTrib.cfopEfora || ''))
                setIdCfopSaidaDentro(parseInt(tribAttributes.data.grupoTrib.cfopSDentro || ''))
                setIdCfopSaidaFora(parseInt(tribAttributes.data.grupoTrib.cfopSFora || ''))

                setIdCstDentro(tribAttributes.data.grupoTrib.cstICMSDentro || '')
                setIdCstFora(tribAttributes.data.grupoTrib.cstICMSFora || '')

                /*
                if (tribAttributes.grupoTrib.cstICMSFora) {
                    setIdCstFora(tribAttributes.grupoTrib.cstICMSFora)
                }
    
                if (tribAttributes.grupoTrib.cstICMSDentro) {
                    setIdCstDentro(tribAttributes.grupoTrib.cstICMSDentro)
                }
                */

                setUserCriador(tribAttributes.data.grupoTrib.name_user_insert || '')
                setUsertAtt(tribAttributes.data.grupoTrib.name_user_last_update || '')

                if (tribAttributes.data.grupoTrib.dt_cadastro) {
                    const dataFormatadaCriacao = moment(tribAttributes.data.grupoTrib.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (tribAttributes.data.grupoTrib.dt_last_update) {
                    const dataFormatadaAtt = moment(tribAttributes.data.grupoTrib.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

            }

            if (tribAttributes.data && idTribDup) {

                setId(0)
                setDescricao(tribAttributes.data.grupoTrib.descricao || '')
                setPICMS(tribAttributes.data.grupoTrib.pICMS?.toString() || '')
                setPPIS(tribAttributes.data.grupoTrib.pPIS?.toString() || '')
                setPCOFINS(tribAttributes.data.grupoTrib.pCOFINS?.toString() || '')
                setCstPisCofins(tribAttributes.data.grupoTrib.cstPisCofins || '')

                setIdCfopEntradaDentro(parseInt(tribAttributes.data.grupoTrib.cfopEdentro || ''))
                setIdCfopEntradaFora(parseInt(tribAttributes.data.grupoTrib.cfopEfora || ''))
                setIdCfopSaidaDentro(parseInt(tribAttributes.data.grupoTrib.cfopSDentro || ''))
                setIdCfopSaidaFora(parseInt(tribAttributes.data.grupoTrib.cfopSFora || ''))

                setIdCstDentro(tribAttributes.data.grupoTrib.cstICMSDentro || '')
                setIdCstFora(tribAttributes.data.grupoTrib.cstICMSFora || '')

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível carregar os dados ${error}`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAttributes()
        inputFocus()
    }, [])

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

        inputFocus()
    }, [])

    const handleChangeTab = async (tab: number) => {
        let newTabs = await tabs.map((item) => {
            if (item.index === tab) {
                itabs[item.index].active = true
            } else {
                itabs[item.index].active = false
            }
            return itabs[item.index]
        })
        setTabs(newTabs)
        searchBoxFocus()
    }

    useEffect(() => {

        if (tabs[0].active) {
            inputFocus()
        }

    }, [tabs])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- INPUTS --------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const descricaoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescricao(e.target.value)
    }

    const pICMSChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPICMS(Funcoes.MaskMoney(e.target.value))
    }

    const pPISChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPPIS(Funcoes.MaskMoney(e.target.value))
    }

    const pCOFINSChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPCOFINS(Funcoes.MaskMoney(e.target.value))
    }

    const cstPisCofinsChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCstPisCofins(Funcoes.MaskMoney(e.target.value))
    }

    const cstICMSDentroChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        //setCodCstDentro(e.target.value)
    }

    const cstICMSForaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        //setCodCstFora(e.target.value)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CFOP ENTRADA DENTRO -------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCfopEntradaDentroSelecionada = useCallback(async () => {
        const newCfopEntradaDentroList = [...await listCFOPEntInterno.filter(item => item.codigo.toString().charAt(0) === '1') || []]
        setListaCFOPEntradaDentroBox(newCfopEntradaDentroList)
        setIdCfopEntradaDentro(0)

        setVisibleSearchBoxEntradaDentro(false)
        boxFocusEntradaDentro()
    }, [listCFOPEntInterno])

    const handleFilterCfopEntradaDentroClick = useCallback(async (description: any) => {
        let CfopEntradaDentro = [...listCFOPEntInterno]

        if (description !== "") {

            if (!isNaN(description)) {

                CfopEntradaDentro = listCFOPEntInterno.filter((item) => {

                    const codigoSubstring = item.codigo.toString().substring(0, 4)
                    return codigoSubstring.startsWith(description)
                })

            } else {

                CfopEntradaDentro = listCFOPEntInterno.filter((item) => item.description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().startsWith(description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase()))
            }

            setListaCFOPEntradaDentroBox(CfopEntradaDentro || [])

        } else {

            //const newCfopEntradaDentroList = [...await listCFOPEntInterno.filter(item => item.codigo.toString().charAt(0) === '1') || []]
            setListaCFOPEntradaDentroBox(CfopEntradaDentro)
        }
    }, [listCFOPEntInterno])

    const handleCfopEntradaDentroSelectClick = useCallback(async (v: CFOP) => {

        if (v) {
            const newCfopEntradaDentroList = [...await listCFOPEntInterno.filter(item => item.codigo.toString().charAt(0) === '1') || []]
            setIdCfopEntradaDentro(v.id)
            setListaCFOPEntradaDentroBox(newCfopEntradaDentroList)
        }

        setVisibleSearchBoxEntradaDentro(false)
        boxFocusEntradaDentro()
    }, [listCFOPEntInterno])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CFOP ENTRADA FORA ---------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCfopEntradaForaSelecionada = useCallback(async () => {
        const newCfopEntradaForaList = [...await listCFOPEntFora.filter(item => item.codigo.toString().charAt(0) === '2') || []]
        setListaCFOPEntradaForaBox(newCfopEntradaForaList)
        setIdCfopEntradaFora(0)

        setVisibleSearchBoxEntradaFora(false)
        boxFocusEntradaFora()
    }, [listCFOPEntFora])

    const handleFilterCfopEntradaForaClick = useCallback(async (description: any) => {
        let CfopEntradaFora = [...listCFOPEntFora]

        if (description !== "") {

            if (!isNaN(description)) {

                CfopEntradaFora = listCFOPEntFora.filter((item) => {

                    const codigoSubstring = item.codigo.toString().substring(0, 4)
                    return codigoSubstring.startsWith(description)
                })

            } else {

                CfopEntradaFora = listCFOPEntFora.filter((item) => item.description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().startsWith(description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase()))
            }

            setListaCFOPEntradaForaBox(CfopEntradaFora || [])

        } else {

            //const newCfopEntradaForaList = [...await listCFOPEntFora.filter(item => item.codigo.toString().charAt(0) === '2') || []]
            setListaCFOPEntradaForaBox(CfopEntradaFora)
        }

    }, [listCFOPEntFora])

    const handleCfopEntradaForaSelectClick = useCallback(async (v: CFOP) => {

        if (v) {
            const newCfopEntradaForaList = [...await listCFOPEntFora.filter(item => item.codigo.toString().charAt(0) === '2') || []]
            setIdCfopEntradaFora(v.id)
            setListaCFOPEntradaForaBox(newCfopEntradaForaList)
        }

        setVisibleSearchBoxEntradaFora(false)
        boxFocusEntradaFora()
    }, [listCFOPEntFora])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CFOP SAIDA DENTRO ---------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCfopSaidaDentroSelecionada = useCallback(async () => {
        const newCfopEntradaForaList = [...await listCFOPSaiInterno.filter(item => item.codigo.toString().charAt(0) === '5') || []]
        setListaCFOPSaidaDentroBox(newCfopEntradaForaList)
        setIdCfopSaidaDentro(0)

        setVisibleSearchBoxSaidaDentro(false)
        boxFocusSaidaDentro()
    }, [listCFOPSaiInterno])

    const handleFilterCfopSaidaDentroClick = useCallback(async (description: any) => {
        let CfopSaidaDentro = [...listCFOPSaiInterno]

        if (description !== "") {

            if (!isNaN(description)) {
                CfopSaidaDentro = listCFOPSaiInterno.filter((item) => {
                    const codigoSubstring = item.codigo.toString().substring(0, 4)
                    return codigoSubstring.startsWith(description)
                })
            } else {
                CfopSaidaDentro = listCFOPSaiInterno.filter((item) => item.description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().startsWith(description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase()))
            }

            setListaCFOPSaidaDentroBox(CfopSaidaDentro || [])

        } else {

            //const newCfopSaidaDentroList = [...await listCFOPSaiInterno.filter(item => item.codigo.toString().charAt(0) === '5') || []]
            setListaCFOPSaidaDentroBox(CfopSaidaDentro)
        }
    }, [listCFOPSaiInterno])

    const handleCfopSaidaDentroSelectClick = useCallback(async (v: CFOP) => {

        if (v) {
            const newCfopSaidaDentroList = [...await listCFOPSaiInterno.filter(item => item.codigo.toString().charAt(0) === '5') || []]
            setIdCfopSaidaDentro(v.id)
            setListaCFOPSaidaDentroBox(newCfopSaidaDentroList)
        }

        setVisibleSearchBoxSaidaDentro(false)
        boxFocusSaidaDentro()
    }, [listCFOPSaiInterno])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CFOP SAIDA FORA ------------------------------------------------------------------ ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCfopSaidaForaSelecionada = useCallback(async () => {
        const newCfopSaidaForaList = [...await listCFOPSaiFora.filter(item => item.codigo.toString().charAt(0) === '6') || []]
        setListaCFOPSaidaForaBox(newCfopSaidaForaList)
        setIdCfopSaidaFora(0)

        setVisibleSearchBoxSaidaFora(false)
        boxFocusSaidaFora()
    }, [listCFOPSaiFora])

    const handleFilterCfopSaidaForaClick = useCallback(async (description: any) => {
        let CfopSaidaFora = [...listCFOPSaiFora]

        if (description !== "") {

            if (!isNaN(description)) {

                CfopSaidaFora = listCFOPSaiFora.filter((item) => {

                    const codigoSubstring = item.codigo.toString().substring(0, 4)
                    return codigoSubstring.startsWith(description)
                })

            } else {

                CfopSaidaFora = listCFOPSaiFora.filter((item) => item.description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase().startsWith(description.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLocaleLowerCase()))
            }

            setListaCFOPSaidaForaBox(CfopSaidaFora || [])

        } else {

            //const newCfopSaidaForaList = [...await listCFOPSaiFora.filter(item => item.codigo.toString().charAt(0) === '6') || []]
            setListaCFOPSaidaForaBox(CfopSaidaFora)
        }

    }, [listCFOPSaiFora])

    const handleCfopSaidaForaSelectClick = useCallback(async (v: CFOP) => {

        if (v) {
            const newCfopSaidaForaList = [...await listCFOPSaiFora.filter(item => item.codigo.toString().charAt(0) === '6') || []]
            setIdCfopSaidaFora(v.id)
            setListaCFOPSaidaForaBox(newCfopSaidaForaList)
        }

        setVisibleSearchBoxSaidaFora(false)
        boxFocusSaidaFora()
    }, [listCFOPSaiFora])


    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CST DENTRO ----------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCstDentroClear = useCallback(() => {
        setIdCstDentro("")
        const newCstDentroList = [...attributes.cstList.filter((item) => item.id.trim().substring(0, 1) === "0")]
        setCstDentroList(newCstDentroList)

        setVisibleSearchBoxICMSDentro(false)
        boxFocusICMSDentro()
    }, [attributes.cstList])

    const handleFilterCstDentro = useCallback((description: any) => {

        let newCstDentroList = [...attributes.cstList.filter((item) => item.id.trim().substring(0, 1) === "0")]

        if (description.trim() !== "") {

            if (!isNaN(description)) {

                newCstDentroList = newCstDentroList.filter((item) => {

                    const codigoSubstring = item.id.toString().substring(0, 3)
                    return codigoSubstring.startsWith(description)
                })

            } else {

                newCstDentroList = newCstDentroList.filter((item) => item.description.toLocaleLowerCase().includes(description.toLocaleLowerCase()))
            }

            setCstDentroList(newCstDentroList)

        } else {

            setCstDentroList(newCstDentroList)
        }
    }, [attributes.cstList])

    const handleSetCstDentro = useCallback((data: any) => {

        if (data) {
            //setCodCstDentro(data.cod_cst)
            setIdCstDentro(data.id)

            let newCstDentroList = [...attributes.cstList.filter((item) => item.id.trim().substring(0, 1) === "0")]
            setCstDentroList(newCstDentroList)
        }

        setVisibleSearchBoxICMSDentro(false)
        boxFocusICMSDentro()
    }, [attributes.cstList])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- CST FORA ------------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleClearCstForaClear = useCallback(() => {
        setIdCstFora("")
        const newCstForaList = [...attributes.cstList.filter((item) => item.id.trim().substring(0, 1) != "0")]
        setCstForaList(newCstForaList)

        setVisibleSearchBoxICMSFora(false)
        boxFocusICMSFora()
    }, [attributes.cstList])

    const handleFilterCstFora = useCallback((description: any) => {
        let newCstForaList = [...attributes.cstList.filter((item) => item.id.trim().substring(0, 1) != "0")]

        if (description.trim() !== "") {

            if (!isNaN(description)) {

                newCstForaList = newCstForaList.filter((item) => {

                    const codigoSubstring = item.id.toString().substring(0, 3)
                    return codigoSubstring.startsWith(description)
                })

            } else {

                newCstForaList = newCstForaList.filter((item) => item.description.toLocaleLowerCase().includes(description.toLocaleLowerCase()))
            }

            setCstForaList(newCstForaList)

        } else {

            setCstForaList(newCstForaList)
        }
    }, [attributes.cstList])

    const handleSetCstFora = useCallback((data: any) => {

        if (data) {
            //setCodCstFora(data.cod_cst)
            setIdCstFora(data.id)

            let newCstForaList = [...attributes.cstList.filter((item) => item.id.trim().substring(0, 1) != "0")]
            setCstForaList(newCstForaList)
        }

        setVisibleSearchBoxICMSFora(false)
        boxFocusICMSFora()
    }, [attributes.cstList])

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- TRIBUTAÇÕES ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const NovoTributacao = () => {

        if (!(parseInt(idTribDup || '') > 0)) {
            setDescricao("")
        }

        setId(0)
        setPICMS("")
        setPPIS("")
        setPCOFINS("")
        setCstPisCofins("")

        setIdCfopEntradaDentro(0)
        setIdCfopEntradaFora(0)
        setIdCfopSaidaDentro(0)
        setIdCfopSaidaFora(0)

        setIdCstDentro("")
        setIdCstFora("")

        setDtCriador('')
        setUserCriador('')
        setDtAtt('')
        setUsertAtt('')

        searchBoxFocus()

        if (messageType === 'DANGER') {
            setVisible(false)
        }

        redefinirCampos()
        inputFocus()

    }

    const handleSaveTributacao = async () => {

        if (messageType === 'DANGER') {
            setVisible(false)
        }
        setLoading(true)
        searchBoxFocus()

        try {

            let tributacao: any = {
                descricao: descricao,
                pICMS: parseFloat(pICMS),
                pPIS: parseFloat(pPIS),
                pCOFINS: parseFloat(pCOFINS),
                cstPisCofins: parseFloat(cstPisCofins),
                cfopEdentro: idCfopEntradaDentro,
                cfopEfora: idCfopEntradaFora,
                cfopSDentro: idCfopSaidaDentro,
                cfopSFora: idCfopSaidaFora,
                cstICMSDentro: idCstDentro,
                cstICMSFora: idCstFora,
            }

            if (id > 0) {
                tributacao.id = id
            }

            const resp = await TributacaoService.Save(tributacao)

            if (resp.error) {

                setVisible(true)
                setMessageType("DANGER")
                setMessage(resp.msg || ``)
                //checkDadosObrigatorios()

            } else {

                setVisible(true)
                setMessageType("SUCCESS")
                setId(resp.id || 0)
                setMessage(id > 0 ? `Dados da tributação atualizados com sucesso` : resp.msg || "")

                if (resp.dt_cadastro) {
                    const dataFormatadaCriacao = moment(resp.dt_cadastro).format('DD/MM/YYYY HH:mm')
                    setDtCriador(dataFormatadaCriacao)
                }

                if (resp.dt_last_update) {
                    const dataFormatadaAtt = moment(resp.dt_last_update).format('DD/MM/YYYY HH:mm')
                    setDtAtt(dataFormatadaAtt)
                }

                setDescricaoCopia(resp.data.trib.descricao)
                setUserCriador(resp.name_user_insert || '')
                setUsertAtt(resp.name_user_last_update || '')

                redefinirCampos()
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(id > 0 ? `Não foi possível atualizar os dados da tributação. Por favor, tente novamente` : `Não foi possível salvar os dados da tributação. Por favor, tente novamente`)

        } finally {
            const timer = setTimeout(() => {
                setLoading(false)
                inputFocus()
                clearTimeout(timer)
            }, 1200)
        }
    }

    const checkDadosObrigatorios = (): boolean => {

        if (descricao.trim() === '') {
            let fieldsM: CampoObrigatorio[] = CamposObrigatorios.map((item) => {
                return { campo: item.campo, erro: item.campo === 'descricao' ? true : false }
            }
            )
            setCamposObrigatorios(fieldsM)
            return true
        }

        return false
    }

    const redefinirCampos = async () => {

        let fieldsM: CampoObrigatorio[] = [
            { campo: 'descricao', erro: false }, // Posição 0 do Array.    
        ]

        setCamposObrigatorios(fieldsM)

    }

    const inputFocus = () => {
        const inputElement = document.getElementById("descricao")
        inputElement?.focus()
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 1 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const inputsRefs: InputsRefs = {
        descricao: useRef(null),
        aliqICMS: useRef(null),
        aliqPIS: useRef(null),
        aliqCONFINS: useRef(null),
        aliqPISCONFINS: useRef(null),
        CfopEntradaDentro: useRef(null),
        CfopEntradaFora: useRef(null),
        CfopSaidaDentro: useRef(null),
        CfopSaidaFora: useRef(null),
        StIcmsDentro: useRef(null),
        StIcmsFora: useRef(null),

    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab' && tabs[0].active) {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            searchBoxFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 5) {
                setVisibleSearchBoxEntradaDentro(true)
                inputFocusEntradaDentro()
            }

            if (nextIndex === 6) {
                setVisibleSearchBoxEntradaFora(true)
                inputFocusEntradaFora()
            }

            if (nextIndex === 7) {
                setVisibleSearchBoxSaidaDentro(true)
                inputFocusSaidaDentro()
            }

            if (nextIndex === 8) {
                setVisibleSearchBoxSaidaFora(true)
                inputFocusSaidaFora()
            }

            if (nextIndex === 9) {
                setVisibleSearchBoxICMSDentro(true)
                inputFocusICMSDentro()
            }

            if (nextIndex === 10) {
                setVisibleSearchBoxICMSFora(true)
                inputFocusICMSFora()
            }


            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab' && tabs[0].active) {

                event.preventDefault()

                const inputSearchEntradaDentro = document.getElementById('inputSearchBox-entradaDentro') as HTMLInputElement
                const inputSearchEntradaFora = document.getElementById('inputSearchBox-entradaFora') as HTMLInputElement
                const inputSearchSaidaDentro = document.getElementById('inputSearchBox-saidaDentro') as HTMLInputElement
                const inputSearchSaidaFora = document.getElementById('inputSearchBox-saidaFora') as HTMLInputElement
                const inputSearchICMSDentro = document.getElementById('inputSearchBox-ICMSDentro') as HTMLInputElement
                const inputSearchICMSFora = document.getElementById('inputSearchBox-ICMSFora') as HTMLInputElement

                if (document.activeElement === inputSearchEntradaDentro) {

                    // quando o focus estiver no campo CFOP de Entrada Dentro e eu apertar tab ele ira para o CFOP de Entrada Fora
                    // e fechar o componente do CFOP de Entrada Dentro

                    clickSearchBoxEntradaFora()
                    setVisibleSearchBoxEntradaDentro(false)

                } else if (document.activeElement === inputSearchEntradaFora) {

                    // quando o focus estiver no campo CFOP de Entrada Fora e eu apertar tab ele ira para o CFOP de Saida Dentro
                    // e fechar o componente do CFOP de Entrada Fora

                    clickSearchBoxSaidaDentro()
                    setVisibleSearchBoxEntradaFora(false)

                } else if (document.activeElement === inputSearchSaidaDentro) {

                    // quando o focus estiver no campo CFOP de Saida Dentro e eu apertar tab ele ira para o CFOP de Saida Fora
                    // e fechar o componente do CFOP de Saida Dentro

                    clickSearchBoxSaidaFora()
                    setVisibleSearchBoxSaidaDentro(false)

                } else if (document.activeElement === inputSearchSaidaFora) {

                    // quando o focus estiver no campo CFOP de Saida Fora e eu apertar tab ele ira para o ST ICMS dentro do estado
                    // e fechar o componente do CFOP de Saida Fora

                    clickSearchBoxICMSDentro()
                    setVisibleSearchBoxSaidaFora(false)

                } else if (document.activeElement === inputSearchICMSDentro) {

                    // quando o focus estiver no campo ST ICMS dentro do estado e eu apertar tab ele ira para o ST ICMS fora do estado
                    // e fechar o componente do ST ICMS dentro do estado

                    clickSearchBoxICMSFora()
                    setVisibleSearchBoxICMSDentro(false)

                } else if (document.activeElement === inputSearchICMSFora) {

                    // quando o focus estiver no campo ST ICMS fora do estado e eu apertar tab ele ira para a Descrição
                    // e fechar o componente do ST ICMS fora do estado

                    inputsRefs['descricao'].current?.focus()
                    setVisibleSearchBoxICMSFora(false)
                }

            }

        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [tabs])

    const searchBoxFocus = () => {
        setVisibleSearchBoxEntradaDentro(false)
        setVisibleSearchBoxEntradaFora(false)
        setVisibleSearchBoxSaidaDentro(false)
        setVisibleSearchBoxSaidaFora(false)
        setVisibleSearchBoxICMSDentro(false)
        setVisibleSearchBoxICMSFora(false)
    }

    // ENTRADA DENTRO -----------------------------------------------------------------
    const boxFocusEntradaDentro = () => {
        // Move o foco para o input correspondente à chave 'CfopEntradaDentro'.
        inputsRefs['CfopEntradaDentro'].current?.focus()
    }

    const clickSearchBoxEntradaDentro = useCallback(() => {
        setVisibleSearchBoxEntradaDentro((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxEntradaDentro
                setVisibleSearchBoxEntradaFora(false)
                setVisibleSearchBoxSaidaDentro(false)
                setVisibleSearchBoxSaidaFora(false)
                setVisibleSearchBoxICMSDentro(false)
                setVisibleSearchBoxICMSFora(false)
                inputFocusEntradaDentro()

            }
            return newState
        })
        boxFocusEntradaDentro()
    }, [])

    const inputFocusEntradaDentro = () => {
        let inputSearch = document.getElementById(`inputSearchBox-entradaDentro`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ENTRADA FORA -----------------------------------------------------------------
    const boxFocusEntradaFora = () => {
        // Move o foco para o input correspondente à chave 'CfopEntradaFora'.
        inputsRefs['CfopEntradaFora'].current?.focus()
    }

    const clickSearchBoxEntradaFora = useCallback(() => {
        setVisibleSearchBoxEntradaFora((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxEntradaFora
                setVisibleSearchBoxEntradaDentro(false)
                setVisibleSearchBoxSaidaDentro(false)
                setVisibleSearchBoxSaidaFora(false)
                setVisibleSearchBoxICMSDentro(false)
                setVisibleSearchBoxICMSFora(false)
                inputFocusEntradaFora()

            }
            return newState
        })
        boxFocusEntradaFora()
    }, [])

    const inputFocusEntradaFora = () => {
        let inputSearch = document.getElementById(`inputSearchBox-entradaFora`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // SAIDA DENTRO -----------------------------------------------------------------
    const boxFocusSaidaDentro = () => {
        // Move o foco para o input correspondente à chave 'CfopSaidaDentro'.
        inputsRefs['CfopSaidaDentro'].current?.focus()
    }

    const clickSearchBoxSaidaDentro = useCallback(() => {
        setVisibleSearchBoxSaidaDentro((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxSaidaDentro
                setVisibleSearchBoxEntradaDentro(false)
                setVisibleSearchBoxEntradaFora(false)
                setVisibleSearchBoxSaidaFora(false)
                setVisibleSearchBoxICMSDentro(false)
                setVisibleSearchBoxICMSFora(false)
                inputFocusSaidaDentro()
            }
            return newState
        })
        boxFocusSaidaDentro()
    }, [])

    const inputFocusSaidaDentro = () => {
        let inputSearch = document.getElementById(`inputSearchBox-saidaDentro`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // SAIDA FORA -----------------------------------------------------------------
    const boxFocusSaidaFora = () => {
        // Move o foco para o input correspondente à chave 'CfopSaidaFora'.
        inputsRefs['CfopSaidaFora'].current?.focus()
    }

    const clickSearchBoxSaidaFora = useCallback(() => {
        setVisibleSearchBoxSaidaFora((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxSaidaFora
                setVisibleSearchBoxEntradaDentro(false)
                setVisibleSearchBoxEntradaFora(false)
                setVisibleSearchBoxSaidaDentro(false)
                setVisibleSearchBoxICMSDentro(false)
                setVisibleSearchBoxICMSFora(false)
                inputFocusSaidaFora()

            }
            return newState
        })
        boxFocusSaidaFora()
    }, [])

    const inputFocusSaidaFora = () => {
        let inputSearch = document.getElementById(`inputSearchBox-saidaFora`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ICMS FORA -----------------------------------------------------------------
    const boxFocusICMSDentro = () => {
        // Move o foco para o input correspondente à chave 'StIcmsDentro'.
        inputsRefs['StIcmsDentro'].current?.focus()
    }

    const clickSearchBoxICMSDentro = useCallback(() => {
        setVisibleSearchBoxICMSDentro((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxICMSDentro
                setVisibleSearchBoxEntradaDentro(false)
                setVisibleSearchBoxEntradaFora(false)
                setVisibleSearchBoxSaidaDentro(false)
                setVisibleSearchBoxSaidaFora(false)
                setVisibleSearchBoxICMSFora(false)
                inputFocusICMSDentro()

            }
            return newState
        })
        boxFocusICMSDentro()
    }, [])

    const inputFocusICMSDentro = () => {
        let inputSearch = document.getElementById(`inputSearchBox-ICMSDentro`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ICMS DENTRO -----------------------------------------------------------------
    const boxFocusICMSFora = () => {
        // Move o foco para o input correspondente à chave 'StIcmsFora'.
        inputsRefs['StIcmsFora'].current?.focus()
    }

    const clickSearchBoxICMSFora = useCallback(() => {
        setVisibleSearchBoxICMSFora((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha os outros search boxes e foca no SearchBoxICMSFora
                setVisibleSearchBoxEntradaDentro(false)
                setVisibleSearchBoxEntradaFora(false)
                setVisibleSearchBoxSaidaDentro(false)
                setVisibleSearchBoxSaidaFora(false)
                setVisibleSearchBoxICMSDentro(false)
                inputFocusICMSFora()

            }
            return newState
        })
        boxFocusICMSFora()
    }, [])

    const inputFocusICMSFora = () => {
        let inputSearch = document.getElementById(`inputSearchBox-ICMSFora`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    //------------------------------------------------------------------- FOCUS ABA 2 ---------------------------------------------------------------------- ||
    //------------------------------------------------------------------------------------------------------------------------------------------------------ ||
    const handleTabPressNone = (event: any) => {

        if (event.key === 'Tab' && tabs[1].active) {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {

        document.addEventListener('keydown', handleTabPressNone)

        return () => {

            document.removeEventListener('keydown', handleTabPressNone)
        }

    }, [tabs])

    const btNovoVisible = parseInt(idTrib || '') > 0 ? 'invisible hidden' : 'visible'

    return (
        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`bg-white dark:bg-slate-600 border border-slate-300 dark:border-slate-800 shadow-md shadow-indigo-200 dark:shadow-slate-800 rounded-lg`}>

                        <div className={`h-[50px] w-full flex items-center my-3 px-2`}>
                            <FcNook className={`text-slate-700 dark:text-slate-200 ml-2 mr-2`} size="25px" color='#333' />
                            <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200 break-all`}> {parseInt(idTrib || '') || id > 0 ? `Editar - Tributação - ${descricaoCopia}` : parseInt(idTribDup || '') > 0 ? 'Duplicar - Tributação' : 'Cadastro - Tributação'} </span>
                        </div>

                        <div className={`w-full h-full`}>

                            <div className={`h-[60px] flex overflow-x-auto scrollable_horizontal border border-slate-200 dark:border-slate-700`}>
                                {tabs.map((item) => {
                                    return (
                                        <button tabIndex={-1} onClick={() => handleChangeTab(item.index)} key={item.index.toString()}
                                            className={`px-4 font-mono font-bold w-[180px]
                                                ${item.active ?
                                                    `hover:text-sky-500 text-sky-600 border border-b-[3px] border-l-0 border-t-0 border-r-slate-300 border-b-sky-600 dark:text-slate-200 dark:border-r-slate-700 dark:border-b-slate-300` :
                                                    `text-sky-600 dark:text-slate-300 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 border border-l-0 border-t-0 border-b-0 dark:border-slate-800`
                                                } `}>
                                            <div tabIndex={-1} className={`flex items-center`}>
                                                <span className={`mr-2`}><Icone icon={item.icon} /></span>
                                                <span className={`text-sm roboto whitespace-nowrap`}>{item.titulo}</span>
                                            </div>
                                        </button>
                                    )
                                })}

                            </div>

                            <div className={`${tabs[0].active ? 'block' : 'hidden'} relative`}>

                                <div className={`w-full grid gap-5 grid-cols-12 p-4`}>

                                    <div className={`relative col-span-12 space-y-1`}>
                                        <div className={`flex flex-row`}>
                                            <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>Dados da Tributação</span>
                                            <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 cursor-pointer`} size={18} />
                                            <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='top' >
                                                <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                                            </Tooltip>
                                        </div>
                                        <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-8 2xl:col-span-4`}>
                                        <div className={`${barraVermelhoAzul} ${descricao != '' ? bgBlue : bgRed}`} />
                                        <input ref={inputsRefs.descricao} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'descricao')} id="descricao" className={`${classInput} ${classInputDark} ${descricao != '' ? '' : focusRed}`} type="text" inputMode='text' maxLength={155} placeholder=" " autoComplete='off' value={descricao} onFocus={searchBoxFocus} onChange={descricaoChange} />
                                        <label htmlFor="descricao" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${descricao != '' ? '' : focusLabelRed}`}>Descrição</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.aliqICMS} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'aliqICMS')} id="pICMS" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={pICMS} onFocus={searchBoxFocus} onChange={pICMSChange} />
                                        <label htmlFor="pICMS" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Alíquota de ICMS</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.aliqPIS} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'aliqPIS')} id="pPIS" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={pPIS} onFocus={searchBoxFocus} onChange={pPISChange} />
                                        <label htmlFor="pPIS" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Alíquota de PIS</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.aliqCONFINS} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'aliqCONFINS')} id="pCOFINS" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={pCOFINS} onFocus={searchBoxFocus} onChange={pCOFINSChange} />
                                        <label htmlFor="pCOFINS" className={`${classLabel} ${classLabelDark}  ${classBorderLabelDark}`}>Alíquota de COFINS</label>
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2`}>
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <input ref={inputsRefs.aliqPISCONFINS} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'aliqPISCONFINS')} id="cstPisCofins" className={`${classInput} ${classInputDark}`} type="text" inputMode='numeric' placeholder=" " autoComplete='off' value={cstPisCofins} onFocus={searchBoxFocus} onChange={cstPisCofinsChange} />
                                        <label htmlFor="cstPisCofins" className={`${classLabel} ${classLabelDark}  ${classBorderLabelDark}`}>ST de Pis/Cofins</label>
                                    </div>

                                    <div className={`relative col-span-12`}>

                                        <div ref={inputsRefs['CfopEntradaDentro']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'CfopEntradaDentro')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={listaCFOPEntradaDentroBox}
                                            idRegistro={idCfopEntradaDentro || undefined}
                                            label='CFOP de Entrada de Serviços do Estado'
                                            componentId='entradaDentro'
                                            limite={true}
                                            visibleTAB={visibleSearchBoxEntradaDentro}
                                            clearDataClick={handleClearCfopEntradaDentroSelecionada}
                                            setDataClick={handleCfopEntradaDentroSelectClick}
                                            filterDataClick={handleFilterCfopEntradaDentroClick}
                                            clicado={clickSearchBoxEntradaDentro}
                                        />
                                    </div>

                                    <div className={`relative col-span-12`}>

                                        <div ref={inputsRefs['CfopEntradaFora']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'CfopEntradaFora')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={listaCFOPEntradaForaBox}
                                            idRegistro={idCfopEntradaFora || undefined}
                                            label='CFOP de Entrada de Serviços de Outros Estados'
                                            componentId='entradaFora'
                                            limite={true}
                                            visibleTAB={visibleSearchBoxEntradaFora}
                                            clearDataClick={handleClearCfopEntradaForaSelecionada}
                                            setDataClick={handleCfopEntradaForaSelectClick}
                                            filterDataClick={handleFilterCfopEntradaForaClick}
                                            clicado={clickSearchBoxEntradaFora}
                                        />
                                    </div>

                                    <div className={`relative col-span-12`}>

                                        <div ref={inputsRefs['CfopSaidaDentro']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'CfopSaidaDentro')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={listaCFOPSaidaDentroBox}
                                            idRegistro={idCfopSaidaDentro || undefined}
                                            label='CFOP de Saida de Serviços do Estado'
                                            componentId='saidaDentro'
                                            limite={true}
                                            visibleTAB={visibleSearchBoxSaidaDentro}
                                            clearDataClick={handleClearCfopSaidaDentroSelecionada}
                                            setDataClick={handleCfopSaidaDentroSelectClick}
                                            filterDataClick={handleFilterCfopSaidaDentroClick}
                                            clicado={clickSearchBoxSaidaDentro}
                                        />
                                    </div>

                                    <div className={`relative col-span-12`}>

                                        <div ref={inputsRefs['CfopSaidaFora']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'CfopSaidaFora')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={listaCFOPSaidaForaBox}
                                            idRegistro={idCfopSaidaFora || undefined}
                                            label='CFOP de Saida de Serviços de Outros Estados'
                                            componentId='saidaFora'
                                            limite={true}
                                            visibleTAB={visibleSearchBoxSaidaFora}
                                            clearDataClick={handleClearCfopSaidaForaSelecionada}
                                            setDataClick={handleCfopSaidaForaSelectClick}
                                            filterDataClick={handleFilterCfopSaidaForaClick}
                                            clicado={clickSearchBoxSaidaFora}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6`}>

                                        <div ref={inputsRefs['StIcmsDentro']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'StIcmsDentro')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={cstDentroList}
                                            idRegistro={idCstDentro || undefined}
                                            label='ST ICMS dentro do estado'
                                            componentId='ICMSDentro'
                                            limite={true}
                                            visibleTAB={visibleSearchBoxICMSDentro}
                                            setDataClick={handleSetCstDentro}
                                            clearDataClick={handleClearCstDentroClear}
                                            filterDataClick={handleFilterCstDentro}
                                            clicado={clickSearchBoxICMSDentro}
                                        />
                                    </div>

                                    <div className={`relative col-span-12 sm:col-span-6`}>

                                        <div ref={inputsRefs['StIcmsFora']} tabIndex={0} onKeyDown={(e: React.KeyboardEvent) => handleTabPress(e, 'StIcmsFora')} />
                                        <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                        <SearchBox
                                            dataList={cstForaList}
                                            idRegistro={idCstFora || undefined}
                                            label='ST ICMS fora do estado'
                                            componentId='ICMSFora'
                                            limite={true}
                                            visibleTAB={visibleSearchBoxICMSFora}
                                            setDataClick={handleSetCstFora}
                                            clearDataClick={handleClearCstForaClear}
                                            filterDataClick={handleFilterCstFora}
                                            clicado={clickSearchBoxICMSFora}
                                        />
                                    </div>

                                </div>

                                <div className={`flex flex-col space-y-3 m-4 sm:space-y-0 sm:space-x-4 sm:flex-row sm:justify-end`}>

                                    <Link tabIndex={-1} onMouseUp={handleMouseUp} to="/tributacao" className={`${classbtColunasVermelho} ${classWeigthBt}`}>
                                        <BsBoxArrowInLeft size="20px" className={`mr-[5px]`} /> Voltar
                                    </Link>

                                    <button tabIndex={-1} onClick={NovoTributacao} className={`${classBt} ${btNovoVisible} ${classbtCinzaClaro} ${classWeigthBt}`}>
                                        <AiOutlineClear size="20px" className={`mr-[5px]`} /> Limpar Campos
                                    </button>

                                    <button tabIndex={-1} onClick={handleSaveTributacao} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt}`}>
                                        {!loading && <IoSave size="16px" className={`mr-[5px]`} />}
                                        {loading &&
                                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-neutral-100 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                            </div>
                                        }
                                        {parseInt(idTrib || '0') > 0 || id != 0 ? !loading ? 'Atualizar' : 'Aguarde' : !loading ? 'Salvar' : 'Aguarde'}
                                    </button>

                                </div>

                            </div>

                            <div className={`${tabs[1].active ? 'block' : 'hidden'} relative h-[400px] sm:h-[200px]`}>

                                <div className={`w-full h-full flex flex-row p-4`}>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userCriacaoTrib" className={`${classUserCriarAtt}`}>Criador</label>
                                            <span id="userCriacaoTrib" className={`${classDtCriarAtt}`}>{userCriador}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtCriacaoTrib" className={`${classUserCriarAtt}`}>Data de Criação</label>
                                            <span id="dtCriacaoTrib" className={`${classDtCriarAtt}`}>{dtCriador}</span>
                                        </div>

                                    </div>

                                    <div className={`w-full grid grid-cols-12`}>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="userAttTrib" className={`${classUserCriarAtt}`}>Atualizador</label>
                                            <span id="userAttTrib" className={`${classDtCriarAtt}`}>{usertAtt}</span>
                                        </div>

                                        <div className={`relative col-span-12 p-2 flex flex-col`}>
                                            <label htmlFor="dtAttTrib" className={`${classUserCriarAtt}`}>Data de Atualização</label>
                                            <span id="dtAttTrib" className={`${classDtCriarAtt}`}>{dtAtt}</span>
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </Template>
    )
}